export default {
  title: 'Ohoh!',
  text: 'Als je (nog) maar 1 Avatar hebt, dan kan je deze niet verwijderen.',
  button: 'Oké'
};
